import _ from "lodash";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App.jsx";

import { insertHeader } from "./insertHeader";
import * as numeral from "numeral";
import "numeral/locales/ru";

insertHeader();
numeral.locale("ru");

ReactDOM.render(
  <>
    <App />
  </>,
  document.getElementById("root")
);
